import { BasicPersistenceService } from '../../../../../shared/services/BasicPersistenceService';
import { AppApplicationModel } from '../models/AppApplicationModel';
import { AppFormModel } from "../models/AppFormModel";

export class AppPersistenceService extends BasicPersistenceService<MyVehicleAppDefinition> {
	public getFormModelFromStore(): AppFormModel {
		const applicationModel = this.getApplicationModel();
		return applicationModel.FormModel;
	}

	public setFormModelToStore(formModel: AppFormModel): void {
		const applicationModel = this.getApplicationModel();
		applicationModel.FormModel = formModel;
		this.setApplicationModel(applicationModel);
	}

	public getApplicationModel(): AppApplicationModel {
		const dataObject = this.getApplicationObject();
		return AppApplicationModel.createFromObject(dataObject);
	}

}
